/**
 *
 * Diagnonal Background Animations
 *
 * UI for animating the background SVG on the homepage
 */

const $ = require( 'jquery' );
const _throttled =  require( './_debounce' );

var DiagonalScroll = function(el){

  this.$el     = $(el);
  this.$svgWrapper = this.$el.find('.itbl-c-diag__wrapper');
  this.$container  = this.$el.find('#itbl-c-diag__group');
  this.$polys    = this.$el.find( '.itbl-c-diag__poly' );
  this.$window  = $(window);

  this.wrapperTimeline = null;
  this.timeline     = null;
  this.proxyTween   = null;
  this.scrollOffset   = .25;
  this.lastScrollTop   = $(window).scrollTop();

  const hasDiagAnimation = $('.disable-diag-animation').length == 0;

  if (hasDiagAnimation) {
    this.init();
  }
};

DiagonalScroll.prototype.init = function(){
  this.wrapperTimeline = new TimelineMax()
    .to(this.$svgWrapper,
      1.5,
      {className:"+=diag--initialized", ease:Power2.easeOut}
    );

  this.timeline = new TimelineMax({ paused: true })
    .to(this.$container, 1, {
      yPercent: -97,
      yoyo : true,
      ease: Linear.easeNone,
      force3D : true
  });

  this.proxyTween = TweenLite
    .to({}, 1700, { repeat : -1, yoyo : true})
    .progress(1)
    .progress(0);

  TweenLite.ticker.addEventListener("tick", ()=> {

    var timelineProgress   = this.timeline.progress();
    var proxyProgress    = this.proxyTween.progress();

    if( this.proxyTween.reversed() && !this.proxyTween.isActive() ){

      this.proxyTween.play();

    }else{

      // ease can be anything from 0.5 to 0.01
      // Change ease to tweak effect
      timelineProgress += (proxyProgress - timelineProgress ) * 0.1;

      this.timeline.progress( timelineProgress );
    }


  });

  this.events();

};

DiagonalScroll.prototype.events = function(){

  this.$window.on( 'scroll', _throttled( 50, this.event__handleScrollProgress.bind(this) ) );

  $(document).on( 'visibilitychange', this.event__visibilityChange.bind(this) );

};

DiagonalScroll.prototype.event__handleScrollProgress = function(event){
  var scrollDiff;
  var scrollDir;


  //get document height
  var documentHeight = document.body.clientHeight;
  //get window height
  var windowHeight = window.innerHeight;
  //get distance of window scrollbar
  var scrollTop = $(window).scrollTop();

  var scrollPercent = Math.max( scrollTop / (documentHeight - windowHeight), 0 );

  scrollDir = scrollTop < this.lastScrollTop;

  // get difference to use as new progress
  scrollDiff = (scrollTop - this.lastScrollTop) / (documentHeight - windowHeight) * this.scrollOffset; // use this to tie scrolling to scroll progress of the window

  // make sure new progress is between 0 and 1 to avoid jumps
  var newProgress = Math.min(Math.max(0, this.proxyTween.progress() + scrollDiff ), 1);

  this.proxyTween.progress(newProgress);

  if ( scrollDir ) {
    this.proxyTween.reverse();
  } else {
    this.proxyTween.play();
  }

  this.lastScrollTop = scrollTop;

};

DiagonalScroll.prototype.event__visibilityChange = function(event){

  //purposely not declaring this variable so that this logic doesn't run on initial page load
  if( typeof this.visibility === 'undefined' ){

    this.visibility = document.hidden;
    return false;
  }

  this.visibility = document.hidden;

  if( this.visibility ){

    this.proxyTween.pause();

  }else{

    this.proxyTween.play();
  }

};

$(document).ready(function(){
  $('.itbl-c-diag').each(function(){
    new DiagonalScroll(this);
  });

});
